import * as actions from "store/actions/subscription/edit";
import ISubscription, { SubscriptionStatus } from "Types/Subscription";
import dayjs from "dayjs";

export interface SubscriptionEditState extends ISubscription {
	item: ISubscription | null;
	loading: boolean;
	errors: any;
	user: any;
}

const initialState: SubscriptionEditState = {
	loading: false,
	item: null,
	value: "",
	discount: "",
	installment: "1",
	installmentInterval: "30",
	description: "",
	user: null,
	plan: "",
	paymentMethod: "",
	firstPayment: dayjs(),
	status: SubscriptionStatus.enabled,
	errors: {}
};

const reducer = function (state = initialState, { type, payload }: any) {
	switch (type) {
		case actions.GET_SUBSCRIPTION: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.GET_SUBSCRIPTION_SUCCESS: {
			return {
				...initialState,
				...payload,
				value: payload.value / 100.0,
				discount: payload.discount / 100.0,
				installment: payload.installment,
				installmentInterval: payload.installmentInterval,
				description: payload.description,
				user: payload.user,
				plan: payload.plan,
				paymentMethod: payload.paymentMethod,
				firstPayment: payload.firstPayment,
				item: payload
			};
		}
		case actions.GET_SUBSCRIPTION_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.EDIT_SUBSCRIPTION: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.EDIT_SUBSCRIPTION_SUCCESS: {
			return {
				...initialState,
				item: payload
			};
		}
		case actions.EDIT_SUBSCRIPTION_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
